export const RouterName = {
  dashboard: '/',
  // listProject: '/list-project',
  projectDetail: '/project-detail',
}
